<template>
  <vs-popup class="lesson-popup" title="" :active.sync="popupActive">
    <!-- <BuyMeClaim/> -->
    <div v-if="lesson" class="min-h-full">
      <component :is="lesson.name" :lesson="lesson" @hidePopup="popupActive=false"/>
    </div>

  </vs-popup>
</template>

<script>
import Responsibility from './Lessons/Responsibility'
import RealityCheck from './Lessons/RealityCheck'
import LetsMeet from './Lessons/LetsMeet'
import TiniestGoal from './Lessons/TiniestGoal'
import SomethingToAimAt from './Lessons/SomethingToAimAt'
import PurposefulRoutine from './Lessons/PurposefulRoutine'

import IncreaseYourChances from './Lessons/IncreaseYourChances'
import HabitsThatStick from './Lessons/HabitsThatStick'
import StopComparingToOthers from './Lessons/StopComparingToOthers'
import LessonContent from './Lessons/LessonContent'

export default {
  props: ['lesson', 'showPopup'],
  components: {
    Responsibility,
    RealityCheck,
    TiniestGoal,
    SomethingToAimAt,
    LessonContent,
    PurposefulRoutine,
    IncreaseYourChances,
    HabitsThatStick,
    StopComparingToOthers,
    LetsMeet
  },
  data () {
    return {
      popupActive: false
    }
  },
  computed: {
  },
  methods: {
  },
  watch: {
    'showPopup': {
      immediate: false,
      handler (showPopup) {
        if (showPopup) {
          this.popupActive = true
        }
      }
    },
    'popupActive': {
      handler (popupActive) {
        if (!popupActive) {
          this.$emit('popupHidden')
        }
      }
    }
  }

}
</script>

<style land="scss">

.lesson-popup .vs-popup--header {
  background: #ffffff
}

@media screen and (min-width: 900px) {
  .lesson-popup .vs-popup {
    width: 75% !important;
  }
}

.lesson-popup .wizard-header {
  display: none;
}

.lesson-popup .wizard-tab-content {
  padding-top: 10px !important;
}
</style>
